module.exports = __webpack_public_path__ + "public/images/icon-check.50ebb57edc57f1b139d2311f8fa18061.svg";